import React from 'react';
import {
  Bookmark,
  ChevronsUp,
  Package,
  Swords,
  TrendingUp,
  Store,
  Crown,
  Home,
  MessageCircle,
  Clapperboard,
  Pickaxe,
  Megaphone,
  Tv,
  Wand2,
  Heart,
  User,
  Globe,
  Star,
  Radio,
  Clock,
  Wallet,
  Handshake,
  Trophy,
  Briefcase,
  LayoutGrid,
  LucideIcon,
  UserPlus,
} from 'lucide-react';
import { routePaths } from '../../routes/routes-path';

export interface NavbarItem {
  id: string | number;
  name: string;
  icon?: React.ReactNode;
  /** Icon lucide dùng cho rail dạng thu/mở (icon + nhãn). */
  Icon?: LucideIcon;
  /** Điểm nhấn màu riêng (vd CAB+ tô vàng). */
  accent?: 'gold';
  /** Tiêu đề nhóm — đặt ở mục ĐẦU mỗi nhóm; sidebar sẽ render header phía trên mục này. */
  group?: string;
  link: string;
}

// Rail trái: gom theo NHÓM chức năng cho gọn (thay vì 1 danh sách phẳng lộn xộn).
// Thứ tự: Khám phá → Kết nối → Sáng tạo → Kiếm tiền & Quảng bá → Ví & Vật phẩm.
export const navbar: NavbarItem[] = [
  // ── Khám phá (nội dung) ──
  { id: 1, name: 'Bảng tin', link: routePaths.home, Icon: Home, group: 'Khám phá' },
  { id: 3, name: 'Video', link: '/videos', Icon: Tv },
  { id: 'reels', name: 'Reels', link: routePaths.reels, Icon: Clapperboard },
  { id: 'old', name: 'Cab xưa', link: routePaths.old, Icon: Clock },
  { id: 'honor', name: 'Vinh danh', link: routePaths.honor, Icon: Trophy },
  { id: 7, name: 'Đã lưu', link: routePaths.savePost, Icon: Bookmark },
  // ── Kết nối (xã hội) ──
  { id: 2, name: 'Chat', link: routePaths.chat, Icon: MessageCircle, group: 'Kết nối' },
  { id: 6, name: 'Bạn bè', link: '/profile?tab=friend', Icon: User },
  { id: 8, name: 'Cộng đồng', link: '/group', Icon: Globe },
  { id: 12, name: 'Clan', link: routePaths.clan, Icon: Swords },
  { id: 'arena', name: 'Arena', link: routePaths.arena, Icon: Trophy },
  { id: 5, name: 'Hẹn hò', link: routePaths.dating, Icon: Heart },
  // ── Sáng tạo ──
  { id: 'studio', name: 'Cab Studio', link: routePaths.studio, Icon: Wand2, group: 'Sáng tạo' },
  { id: 9, name: 'Gợi ý Creator', link: '/creators/request', Icon: Star },
  // ── Kiếm tiền & Quảng bá ──
  // CAB+ (gói cao cấp): tô vàng để nổi bật, không bị khuất.
  { id: 'cabplus', name: 'CAB+', link: '/account/cabplus', Icon: Crown, accent: 'gold', group: 'Kiếm tiền & Quảng bá' },
  { id: 'dao-ca', name: 'Ca đào', link: routePaths.daoCa, Icon: Pickaxe },
  { id: 'donate', name: 'Công cụ livestream', link: routePaths.donate, Icon: Radio },
  { id: 'campaigns', name: 'Sàn chiến dịch', link: routePaths.campaigns, Icon: LayoutGrid },
  { id: 'brand-deals', name: 'Sàn hợp tác sáng tạo', link: routePaths.brandDeals, Icon: Briefcase },
  // Trang riêng của người thuê: tạo chiến dịch, brief, đơn nhận đề xuất (sếp góp ý 14/10).
  { id: 'thue-creator', name: 'Thuê creator', link: routePaths.brandOrderer, Icon: UserPlus },
  { id: 'partner', name: 'Hợp tác cùng Cab', link: routePaths.partner, Icon: Handshake },
  { id: 'ads', name: 'Quảng cáo', link: routePaths.ads, Icon: Megaphone },
  // ── Ví & Vật phẩm ──
  { id: 'vi-ca', name: 'Ví Ca', link: routePaths.wallet, Icon: Wallet, group: 'Ví & Vật phẩm' },
  { id: 10, name: 'Cửa hàng', link: routePaths.marketplace, Icon: Store },
  { id: 11, name: 'Kho đồ', link: routePaths.inventory, Icon: Package },
];

export const navbarVideos: NavbarItem[] = [
  {
    id: 1,
    name: 'Trang chủ',
    link: routePaths.home,
    icon: <TrendingUp size={18} />,
  },
  {
    id: 2,
    name: 'Video trending',
    link: '/dating',
    icon: <TrendingUp size={18} />,
  },
  {
    id: 3,
    name: 'Video mới',
    link: routePaths.friend,
    icon: <ChevronsUp size={18} />,
  },
  {
    id: 4,
    name: 'Video đã lưu',
    link: '/creators/request',
    icon: <Bookmark size={18} />,
  },
];
